import React from 'react'

interface IcOverdueProps extends React.SVGProps<SVGSVGElement> {
  width?: string
  height?: string
  color?: string
  style?: React.CSSProperties
}

const IcOverdue: React.FC<IcOverdueProps> = ({
  width = '16px',
  height = '16px',
  color = '#FD4C45',
  style,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
      style={{ flexShrink: 0, ...style }}
      {...props}
    >
      <g clipPath="url(#clip0_16187_964)">
        <path
          d="M8.00001 5.53705V8.50001L10.2222 10.7222M14.6667 8.50001C14.6667 12.1819 11.6819 15.1667 8.00001 15.1667C4.31811 15.1667 1.33334 12.1819 1.33334 8.50001C1.33334 4.81811 4.31811 1.83334 8.00001 1.83334C11.6819 1.83334 14.6667 4.81811 14.6667 8.50001Z"
          stroke="currentColor"
          strokeWidth="2.22222"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_16187_964">
          <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default IcOverdue
